import dayjs from "dayjs";

export const calculateDuration = (
  start?: string | dayjs.Dayjs | null,
  end?: string | dayjs.Dayjs | null,
) => {
  if (!start || !end) return null;
  const diffDays = dayjs(end).diff(dayjs(start), "day");
  if (diffDays <= 0) return null;

  if (diffDays < 7) {
    return `${diffDays} Night${diffDays > 1 ? "s" : ""}`;
  } else if (diffDays < 30) {
    const weeks = Math.floor(diffDays / 7);
    const days = diffDays % 7;
    return `${weeks} Week${weeks > 1 ? "s" : ""}${days > 0 ? `, ${days} Night${days > 1 ? "s" : ""}` : ""}`;
  } else {
    const months = Math.floor(diffDays / 30);
    const days = diffDays % 30;
    return `${months} Month${months > 1 ? "s" : ""}${days > 0 ? `, ${days} Night${days > 1 ? "s" : ""}` : ""}`;
  }
};
